module.exports = __webpack_public_path__ + "static/img/15.00a09793.png";